export enum EFilterNames {
	BRAND = 'Brand',
	MODEL_NAME = 'Model Name',
	COLOR = 'Color',
	FUEL_TYPE = 'Fuel Type',
	TRANSMISSION = 'Transmission',
	SORT = 'Sort',
	SEATS = 'Seats',
	AVERAGE_FUEL_CONSUMPTION = 'Average Fuel Consumption',
	SEGMENT = 'Segment',
	GROUP = 'Group',
	DOORS = 'Doors',
	PRICE = 'Price',
}

export enum ESortValues {
	MOST_POPULAR = '-popularity',
	PRICE_ASC = 'price',
	PRICE_DESC = '-price',
	DEFAULT = 'segment_sort_order',
}

export interface ICarSelectedFilters {
	parameter: IProductParameterModel
	values: string[] | number[]
	min?: number
	max?: number
}

export interface IPriceRange {
	name: string
	value: string
	min: number
	max?: number
}

export interface ICarSorting {
	name: string
	value: ESortValues
}

export interface ICarsUrlState {
	groups: string[]
	transmission: string[]
	fuelType: string[]
	seatsMin: number | null
	priceMin: number | null
	priceMax: number | null
	sort: ESortValues | null
	page: number
	limit: number
	dateOut: string | null
	dateIn: string | null
	officeId: string | null
}

export interface IPaginationState {
	currentPage: number
	totalPages: number
	total: number
	perPage: number
}

export const CARS_URL_DEFAULTS = {
	page: 1,
	limit: 18,
} as const

export const URL_PARAM_TO_API_ID: Record<string, number | string> = {
	transmission: 8,
	fuel_type: 3,
	seats_min: 7,
	group: 'group_id',
	price: 'price',
} as const
